<template>
  <div>
    <!-- 大小限制start -->
    <div class="p-20 w-500 bor-gray m-b-30">
      <div class="h-30">大小限制</div>
      <div>
        <el-form ref="form" :model="curInput.image.size" label-width="100px" v-loading="loading">
          <el-form-item label="图片大小(KB)">
            <el-input class="w-300 m-r-20" v-model="curInput.image.size_limit.size.config" :disabled="curInput.image.size_limit.size.is_limited == 0"></el-input>
            <el-checkbox v-model="curInput.image.size_limit.size.is_limited" :true-label="0" :false-label="1">不限制</el-checkbox>
          </el-form-item>
          <el-form-item label="高限制(PX)">
            <el-input v-model="curInput.image.size_limit.height.config[0]" class="w-140 m-r-10" :disabled="curInput.image.size_limit.height.is_limited == 0"></el-input>~<el-input v-model="curInput.image.size_limit.height.config[1]" class="w-140 m-l-10 m-r-20" :disabled="curInput.image.size_limit.height.is_limited == 0"></el-input>
            <el-checkbox v-model="curInput.image.size_limit.height.is_limited" :true-label="0" :false-label="1">不限制</el-checkbox>
          </el-form-item>
          <el-form-item label="宽限制(PX)">
            <el-input v-model="curInput.image.size_limit.width.config[0]" class="w-140 m-r-10" :disabled="curInput.image.size_limit.width.is_limited == 0"></el-input>~<el-input v-model="curInput.image.size_limit.width.config[1]" class="w-140 m-l-10 m-r-20" :disabled="curInput.image.size_limit.width.is_limited == 0"></el-input>
            <el-checkbox v-model="curInput.image.size_limit.width.is_limited" :true-label="0" :false-label="1">不限制</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 大小限制end -->

    <!-- 图片处理start -->
    <div class="p-20 w-500 bor-gray m-b-30">
      <div class="h-30">图片处理</div>
      <div class="m-t-5 m-b-10">
        <span class="m-r-15">处理方式</span>
        <el-radio-group v-model="curInput.image.deal_config.type">
          <el-radio :label="10">不处理</el-radio>
          <el-radio :label="20">前端处理</el-radio>
          <el-radio :label="30">后端处理</el-radio>
        </el-radio-group>
      </div>
      <div v-if="curInput.image.deal_config.type != 10">
        <div class="m-b-10">
          <el-checkbox v-model="curInput.image.deal_config.is_zoom" :true-label="1" :false-label="0">缩放</el-checkbox>
        </div>
        <div class="m-b-10">
          <span class="m-r-10">尺寸</span>
          <el-input class="w-140 m-r-10" placeholder="高" v-model="curInput.image.deal_config.zoom_config.height" :disabled="curInput.image.deal_config.is_zoom == 0"></el-input>
          <el-input class="w-140" placeholder="宽" v-model="curInput.image.deal_config.zoom_config.width" :disabled="curInput.image.deal_config.is_zoom == 0"></el-input>
        </div>
<!--         <div class="m-b-10">*只填高，则宽度适应；只填宽，则高度适应</div> -->
      </div>
      <div v-if="curInput.image.deal_config.type == 20">
        <div class="m-b-10">
          <el-checkbox v-model="curInput.image.deal_config.is_fix_scale" :true-label="1" :false-label="0">选框固定比例</el-checkbox>
        </div>
        <div>
          <span class="m-r-10">高宽比</span>
          <el-input class="w-140 m-r-10" placeholder="高" v-model="curInput.image.deal_config.fix_scale_config[0]" :disabled="curInput.image.deal_config.is_fix_scale == 0"></el-input>
          <el-input class="w-140" placeholder="宽" v-model="curInput.image.deal_config.fix_scale_config[1]" :disabled="curInput.image.deal_config.is_fix_scale == 0"></el-input>
        </div>
      </div>
      <div v-if="curInput.image.deal_config.type == 30">
        <div>
          <div class="m-b-10">
            <el-checkbox v-model="curInput.image.deal_config.is_cut" :true-label="1" :false-label="0">裁剪</el-checkbox>
          </div>
          <div>
            <span class="m-r-10">尺寸(PX)</span>
            <el-input class="w-140 m-r-10" placeholder="高" v-model="curInput.image.deal_config.cut_config.height" :disabled="curInput.image.deal_config.is_cut == 0"></el-input>
            <el-input class="w-140" placeholder="宽" v-model="curInput.image.deal_config.cut_config.width" :disabled="curInput.image.deal_config.is_cut == 0"></el-input>
          </div>
          <div class="m-t-10 m-b-10">
            <span class="m-r-10">裁剪位置</span>
            <el-radio-group v-model="curInput.image.deal_config.cut_config.position">
              <el-radio :label="10" :disabled="curInput.image.deal_config.is_cut == 0">居中裁切</el-radio>
              <el-radio :label="20" :disabled="curInput.image.deal_config.is_cut == 0">左上角裁切</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div>
          <div class="m-b-10">
            <el-checkbox v-model="curInput.image.deal_config.is_compress" :true-label="1" :false-label="0">质量压缩</el-checkbox>
          </div>
          <div>
            <span class="m-r-10">质量度</span>
            <el-input class="w-400" placeholder="0-100" v-model="curInput.image.deal_config.compress_quality" :disabled="curInput.image.deal_config.is_compress == 0"></el-input>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片处理end -->

    <!-- 缩略图start -->
    <div class="p-20 w-500 bor-gray m-b-30">
      <div class="h-30">缩略图</div>
      <div class="m-t-10 m-b-10">
        <span class="m-r-10">是否生成缩略图</span>
        <el-radio-group v-model="curInput.image.thumb_config.is_thumb">
          <el-radio :label="0">不生成</el-radio>
          <el-radio :label="1">生成</el-radio>
        </el-radio-group>
      </div>
      <div class="bor-gray p-20 m-b-10 pos-rel" v-if="curInput.image.thumb_config.is_thumb" v-for="(item, index) in curInput.image.thumb_config.config">
        <div style="position: absolute;top: 20px;right: 20px;color: red;cursor: pointer;z-index: 1000;" v-if="index != 0" @click="deleteThumb(index)">删除</div>
        <el-form ref="form" label-width="100px" v-loading="loading">
          <el-form-item label="尺寸(PX)">
            <el-input class="w-140 m-r-10" placeholder="高" v-model="item.height"></el-input>
            <el-input class="w-140" placeholder="宽" v-model="item.width"></el-input>
          </el-form-item>
          <el-form-item label="缩放处理方式">
            <el-radio-group v-model="item.thumb_type">
              <el-radio :label="10">拉伸</el-radio>
              <el-radio :label="20">高度适应裁切</el-radio>
              <el-radio :label="30">宽度适应裁切</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <button class="w-100p" style="height: 36px;background-color: #5bb1fa;border: 0;color: #ffffff;border-radius: 3px;outline: none;" type="button" @click="addThumb" v-if="curInput.image.thumb_config.is_thumb">增加</button>
    </div>
    <!-- 缩略图end -->

    <!-- 只读显示start -->
    <div class="p-20 w-500 bor-gray m-b-30">
      <div class="h-30">列表/表单只读显示</div>
      <div>
        <el-form ref="form" label-width="150px" v-loading="loading">
          <el-form-item label="表单中只读尺寸(PX)">
            <el-input class="w-140 m-r-10" placeholder="高" v-model="curInput.image.display_config.form_display.height"></el-input>
            <el-input class="w-140" placeholder="宽" v-model="curInput.image.display_config.form_display.width"></el-input>
          </el-form-item>
          <el-form-item label="列表尺寸(PX)">
            <el-input class="w-140 m-r-10" placeholder="高" v-model="curInput.image.display_config.list_display.height"></el-input>
            <el-input class="w-140" placeholder="宽" v-model="curInput.image.display_config.list_display.width"></el-input>
          </el-form-item>
          <el-form-item label="鼠标悬浮显示大图(PX)">
            <el-checkbox-group v-model="curInput.image.display_config.suspension_type">
              <el-checkbox :label="10">表单</el-checkbox>
              <el-checkbox :label="20">列表</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 只读显示end -->

    <!-- 移动端配置start -->
    <div class="p-20 w-500 bor-gray m-b-30">
      <div class="h-30">移动端配置</div>
      <div>
        <el-form ref="form" :model="curInput" label-width="150px" v-loading="loading">
          <el-form-item label="表单中只读尺寸(PX)">
            <el-input class="w-140 m-r-10" placeholder="高" v-model="curInput.image.mobile_config.readonly_size_form.height"></el-input>
            <el-input class="w-140" placeholder="宽" v-model="curInput.image.mobile_config.readonly_size_form.width"></el-input>
          </el-form-item>
          <!-- <el-form-item label="从那里获取图片(PX)">
            <el-radio-group v-model="curInput.image.mobile_config.from">
              <el-radio :label="10">相册</el-radio>
              <el-radio :label="20">相机</el-radio>
              <el-radio :label="30">两者均可</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form> -->
      </div>
    </div>
    <!-- 移动端配置end -->
  </div>
</template>

<script>
  export default {
    props: ['curInput'],
    data() {
      return {}
    },
    watch: {
      'curInput.image.deal_config.type' (val, oldVal) {
        let obj = this.curInput.image.deal_config
        obj.compress_quality = ''
        obj.cut_config.height = ''
        obj.cut_config.position = ''
        obj.cut_config.width = ''
        obj.fix_scale_config = []
        obj.is_compress = 0
        obj.is_cut = 0
        obj.is_fix_scale = 0
        if (val == 10) {
          obj.is_zoom = 0
          obj.zoom_config.height = ''
          obj.zoom_config.width = ''
        }
      },
      'curInput.image.thumb_config.is_thumb' (val, oldVal) {
        if (val == 0) {
          let list = this.curInput.image.thumb_config.config
          list.splice(0, list.length)
          list.push({
            height: '',
            width: '',
            thumb_type: ''
          })
        }
      },
      'curInput.image.size_limit.height.is_limited' (val, oldVal) {
        if (val == 0) {
          let list = this.curInput.image.size_limit.height.config
          list.splice(0, list.length)
          console.log(list)
        }
      },
      'curInput.image.size_limit.width.is_limited' (val, oldVal) {
        if (val == 0) {
          this.curInput.image.size_limit.width.config = []
        }
      },
      'curInput.image.size_limit.size.is_limited' (val, oldVal) {
        if (val == 0) {
          this.curInput.image.size_limit.size.config = ''
        }
      },
      'curInput.image.deal_config.is_zoom' (val, oldVal) {
        if (val == 0) {
          this.curInput.image.deal_config.zoom_config.height = ''
          this.curInput.image.deal_config.zoom_config.width = ''
        }
      },
      'curInput.image.deal_config.is_fix_scale' (val, oldVal) {
        if (val == 0) {
          this.curInput.image.deal_config.fix_scale_config = []
        }
      },
      'curInput.image.deal_config.is_cut' (val, oldVal) {
        if (val == 0) {
          this.curInput.image.deal_config.cut_config.height = ''
          this.curInput.image.deal_config.cut_config.width = ''
          this.curInput.image.deal_config.cut_config.position = ''
        }
      },
      'curInput.image.deal_config.is_compress' (val, oldVal) {
        if (val == 0) {
          this.curInput.image.deal_config.compress_quality = ''
        }
      }
    },
    methods: {
      addThumb() {
        this.curInput.image.thumb_config.config.push({
          height: '',
          width: '',
          thumb_type: ''
        })
      },
      deleteThumb(index) {
        this.curInput.image.thumb_config.config.splice(index, 1)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// photoConfig.vue?461e0b7a